import { gql, useLazyQuery, useQuery } from '@apollo/client';
import { TEMPLATE_TEXT_FIELDS } from "../../fragments";
export const GET_TEMPLATE_TEXT_BY_CODE_AND_BU = gql`
  ${TEMPLATE_TEXT_FIELDS}
  query templateTextByCodeAndBusinessUnit($code: String, $businessUnit: String, $objectTypeId: Int) {
    templateText_read_byCodeAndBusinessUnit(code: $code, businessUnit: $businessUnit, objectTypeId: $objectTypeId) {
      ...TemplateTextFields
    }
  }
`;
export const GET_TEMPLATE_TEXT_BY_CODE_AND_BU_WITH_LOCALE = gql`
  ${TEMPLATE_TEXT_FIELDS}
  query templateTextByCodeAndBusinessUnitWithLocale($code: String, $businessUnit: String, $objectTypeId: Int) {
    templateText_read_byCodeAndBusinessUnitWithLocale(
      code: $code
      businessUnit: $businessUnit
      objectTypeId: $objectTypeId
    ) {
      ...TemplateTextFields
    }
  }
`;
export const useTemplateTextByCodeAndBusinessUnitLazyQuery = options => {
  return useLazyQuery(GET_TEMPLATE_TEXT_BY_CODE_AND_BU, options);
};
export const useTemplateTextByCodeAndBusinessUnitQuery = options => {
  return useQuery(GET_TEMPLATE_TEXT_BY_CODE_AND_BU, options);
};
export const useTemplateTextByCodeAndBusinessUnitWithLocaleLazyQuery = options => {
  return useLazyQuery(GET_TEMPLATE_TEXT_BY_CODE_AND_BU_WITH_LOCALE, options);
};
export const useTemplateTextByCodeAndBusinessUnitWithLocaleQuery = options => {
  return useQuery(GET_TEMPLATE_TEXT_BY_CODE_AND_BU_WITH_LOCALE, options);
};